import { render, staticRenderFns } from "./product.vue?vue&type=template&id=1fc365ad&scoped=true&"
import script from "./product.vue?vue&type=script&lang=js&"
export * from "./product.vue?vue&type=script&lang=js&"
import style0 from "./product.vue?vue&type=style&index=0&id=1fc365ad&prod&lang=scss&scoped=true&"
import style1 from "./product.vue?vue&type=style&index=1&id=1fc365ad&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc365ad",
  null
  
)

export default component.exports